import React from 'react';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { Columns } from '@components/Columns';
import { Text } from '@components/typography';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { homePageData } from '@data-ts/pages/home';
import { SectionWrapper, StyledColumns, ContentColumn, StyledFlex, StyledButton, StyledTextTitle, StyledText } from './Writersblock.styles';
import { getRootUrl } from '@utils/urlHelpers.util';

const SECTION_ID = 'New_Rachel_Zoe_Expert_Curations';
const { image, imageMobile, title, promptTitle, promptLinkText, prompts, prompts1, ctaText, link } = homePageData.chatGPTWritersblock;

export const Writersblock: React.FC = () => {
  return (
    <Box as="section" id={SECTION_ID} padding={6} backgroundColor="yellow1">
      <SectionWrapper
        background={cloudAssetUrl(image)}
        backgroundMobile={cloudAssetUrl(imageMobile)}
        paddingTop={[9, 0]}
        alignItems={['flex-start', 'center']}
      >
        <StyledColumns centered>
          <ContentColumn width={8}>
            <Flex flexDirection="column" justifyContent="center" alignItems={['center', 'flex-start']}>
              <Text variant="hed72Hero" tagName="h2" color="neutra6" textAlign={['center', 'left']} style={{ maxWidth: '592px' }}>
                {title}
              </Text>
              <StyledFlex paddingTop={[0, 0, 3]} alignItems="flex-start" flexDirection={['column', 'row']}>
                <StyledTextTitle variant="caption" tagName="h3" color="linkDefault">
                  {promptTitle}
                </StyledTextTitle>
                <Flex flexDirection="column">
                  {prompts.map((prompt, index) => (
                    <StyledText key={index + prompt} variant="caption" tagName="h3" color="mono1">
                      {prompt}
                    </StyledText>
                  ))}
                  <StyledTextTitle variant="caption" tagName="h3" color="linkDefault">
                    {promptLinkText}
                  </StyledTextTitle>
                  {prompts1.map((prompt, index) => (
                    <StyledText key={index + prompt} variant="caption" tagName="h3" color="mono1">
                      {prompt}
                    </StyledText>
                  ))}
                  <Flex marginTop={6} justifyContent={['center', 'flex-start']}>
                    <StyledButton id="Home_ChatGPT_Writersblock" href={getRootUrl(link)} forwardedAs={'a'} variant="primary">
                      {ctaText}
                    </StyledButton>
                  </Flex>
                </Flex>
              </StyledFlex>
            </Flex>
          </ContentColumn>
          <Columns.Column width={4}></Columns.Column>
        </StyledColumns>
      </SectionWrapper>
    </Box>
  );
};
